module.exports = __webpack_public_path__ + "static/media/lock-24px.38fb5434.svg";